// bd-deepcontext-zgbz — the locked segmented switch: a ghost-bg pill track with
// the selected option lifted onto `surface` in accent ink. Same chrome as the
// Universe anchor-mode toggle (Clusters/AnchorBar) and ui/tabs.tsx, but with
// button/`aria-pressed` semantics because these are form controls, not tabs.
import React from "react";

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

interface SegmentedSwitchProps<T extends string> {
  label: string;
  value: T;
  options: SegmentedOption<T>[];
  onChange: (value: T) => void;
}

function SegmentedSwitch<T extends string>({
  label,
  value,
  options,
  onChange,
}: SegmentedSwitchProps<T>) {
  return (
    <div
      role="group"
      aria-label={label}
      className="inline-flex rounded-full bg-ghost-bg p-0.5 text-xs font-bold"
    >
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(option.value)}
            className={`rounded-full px-4 py-1.5 transition-colors ${
              active
                ? "bg-surface text-accent-active shadow-sm"
                : "text-ink-muted hover:text-ink"
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedSwitch;
